// extracted by mini-css-extract-plugin
export default {"section":"responsiveStyles_section__qsrKf","inner":"responsiveStyles_inner__QZXSy","timeline":"responsiveStyles_timeline__8V5U9"};